import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        dark: true,
        options: {
            customProperties: true
        },
        themes: {
            dark: {
                primary: '#3b82f6',
                secondary: '#06b6d4',
                accent: '#8b5cf6',
                success: '#10b981',
                warning: '#f59e0b',
                error: '#ef4444',
                info: '#06b6d4',
                background: '#0d0d0f',
                surface: '#1e1e21',
                dark: '#0d0d0f'
            }
        }
    }
});
